import Reveal from '@/components/base/Reveal';
import { philosophy } from '@/mocks/about';

export default function Philosophy() {
  return (
    <section className="relative py-20 md:py-28">
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-background-50 via-background-100/20 to-background-50" />
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
        <div className="w-[560px] h-[560px] rounded-full bg-primary-500/8 blur-[130px]" />
      </div>

      <div className="relative mx-auto max-w-7xl px-4 md:px-6">
        <Reveal className="text-center max-w-2xl mx-auto">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/30 bg-primary-500/10 px-4 py-1.5 text-xs font-label font-semibold text-primary-400">
            The Philosophy
          </span>
          <h2 className="mt-6 font-heading font-bold text-3xl md:text-4xl text-foreground-950">
            Marketing Is a Business System — Not a Collection of Random Tactics.
          </h2>
          <p className="mt-4 text-foreground-600">
            The principles that guide every strategy, engagement, and decision.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-5">
          {philosophy.map((p, i) => (
            <Reveal key={p.title} delay={i * 60}>
              <div className="h-full rounded-xl border border-white/8 bg-background-100 p-7">
                <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-500/15 text-primary-400">
                  <i className={`${p.icon} text-xl`}></i>
                </span>
                <h3 className="mt-5 font-heading font-semibold text-lg text-foreground-950">
                  {p.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{p.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}